export const KOMISI_CABANG_GET_REQUEST = "KOMISI_CABANG_GET_REQUEST";
export const KOMISI_CABANG_GET_SUCCESS = "KOMISI_CABANG_GET_SUCCESS";
export const KOMISI_CABANG_GET_FAIL = "KOMISI_CABANG_GET_FAIL";
export const KOMISI_CABANG_GET_RESET = "KOMISI_CABANG_GET_RESET";
